import { guest, userInjectionKey } from '#shared'
import { computed, inject, unref, type MaybeRef } from 'vue'
import type { Emoji } from '#features/emoji-selection'
import type { Message } from '#entities/message'
import { useAddReactionMutation } from '../../../entities/message/state/use-add-reaction-mutation'
import { useDeleteReactionMutation } from '../../../entities/message/state/use-delete-reaction-mutation'

export function useToggleReaction(message: MaybeRef<Message>) {
  const currentUser = inject(userInjectionKey)

  const chatId = computed(() => unref(message).chatId)
  const messageId = computed(() => unref(message).id)

  const addReactionMutation = useAddReactionMutation(chatId, messageId)
  const removeReactionMutation = useDeleteReactionMutation(chatId, messageId)

  const toggleReaction = (emoji: Emoji) => {
    const currentUserVal = unref(currentUser)
    if (currentUserVal === guest) return

    const messageVal = unref(message)

    const existingReaction = messageVal.reactions.find(
      reaction => reaction.char === emoji.char && reaction.sender?.id === currentUserVal?.id
    )

    if (existingReaction) {
      removeReactionMutation.mutate(existingReaction.id)
    } else {
      addReactionMutation.mutate({ char: emoji.char })
    }
  }

  return toggleReaction
}
